module.exports = __webpack_public_path__ + "img/cases_bg.c1a90d9a.png";